import type { Task } from "@medplum/fhirtypes";
import { taskNumber } from "@repo/api";

/**
 * Parse a Task's description into title + body.
 * Convention: first line is the title, everything after `\n\n` is the body.
 */
export function parseTaskDescription(description: string | undefined): { title: string; body: string } {
  if (!description) return { title: "", body: "" };
  const idx = description.indexOf("\n\n");
  if (idx === -1) return { title: description, body: "" };
  return { title: description.slice(0, idx), body: description.slice(idx + 2) };
}

export function getTaskTitle(task: Task): string {
  if (task.description) return parseTaskDescription(task.description).title;
  if (task.code?.coding?.[0]?.display) return task.code.coding[0].display;
  if (task.code?.text) return task.code.text;
  return "Untitled Task";
}

/**
 * The human-facing task number (`MF-1234`), selected BY its system rather than
 * by excluding known-internal ones. The exclusion list it replaced surfaced the
 * domain identity UUID the moment ADR-0020 added a new internal system to the
 * array — every internal identifier added later would have done the same.
 */
export function getTaskIdentifier(task: Task): string | undefined {
  return taskNumber(task.identifier);
}
